<template>
  <div id="login">
    <header>
      <div class="title">
        <div>{{$t('choose')}}</div>
        <div class="s-bold">{{$t('category')}}</div>
        <div>{{$t('actuation')}}</div>
      </div>
    </header>
    <ul class="cates">
      <li v-for="(cate,idx) in cates" :key="idx" @click="login(cate)">
        <img-v3 :src="cate.imgSrc" />
        <div class="info">
          <span>{{cate.title}}</span>
          <div>{{cate.desc}}</div>
        </div>
        <span class="arrow"></span>
      </li>
    </ul>
    <div class="income">
      <div class="titles">
        <div class="tip1 s-bold">{{$t("income_title1")}}</div>
        <div class="tip2">{{$t("income_title2")}}</div>
      </div>
      <ul class="login-intro">
        <li class="login-intro-list">
          <img-v3 :src="introList_icon1" class="login-intro-icon" />
          <div>
            <p class="login-intro-title h-bold">{{ $t('login_intro_title_1') }}</p>
            <p class="login-intro-desc h-light">{{ $t('login_intro_desc_1') }}</p>
          </div>
        </li>
        <li class="login-intro-list">
          <img-v3 :src="introList_icon2" class="login-intro-icon" />
          <div>
            <p class="login-intro-title h-bold">{{ $t('login_intro_title_2') }}</p>
            <p class="login-intro-desc h-light">{{ $t('login_intro_desc_2') }}</p>
          </div>
        </li>
        <li class="login-intro-list">
          <img-v3 :src="introList_icon3" class="login-intro-icon" />
          <div>
            <p class="login-intro-title h-bold">{{ $t('login_intro_title_3') }}</p>
            <p class="login-intro-desc h-light">{{ $t('login_intro_desc_3') }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { showLoadingToast } from "../../tools/Tip";
import { LOGIN_CONFIG, ends } from "../../tools/constant";
export default {
  data() {
    return {
      apollo: false, //true使用新版sdk
      loginUrl: process.env.LOGIN_URL,
      introList_icon1: require("../../images/bitmap@3x.png"),
      introList_icon2: require("../../images/bitmap2@3x.png"),
      introList_icon3: require("../../images/bitmap3@3x.png"),
      cates: [
        {
          imgSrc: require("../../images/car_pop@3x.png"),
          desc: this.$t("pop_desc"),
          title: this.$t("pop"),
          pid: "2",
          redirectUrl: `${location.protocol}//${location.host}${location.pathname}`,
          category: "pop"
        },
        {
          imgSrc: require("../../images/car-99taxi@3x.png"),
          desc: this.$t("taxi_desc"),
          title: this.$t("taxi"),
          pid: "1",
          redirectUrl: `${location.protocol}//${location.host}${location.pathname}`,
          category: "taxi"
        },
        {
          imgSrc: require("../../images/car_top@3x.png"),
          desc: this.$t("top_desc"),
          title: this.$t("top"),
          pid: "3",
          redirectUrl: `${location.protocol}//${location.host}${location.pathname}`,
          category: "top"
        }
      ]
    };
  },
  computed: {
    country() {
      return this.params.get("location_country");
    },
    params() {
      return new URLSearchParams(location.search);
    }
  },
  mounted() {
    try {
      Omega.trackEvent("gd_carType_view_sw", "", {
        appsflyer_uid: this.params.get("appsflyer_uid")
      });
    } catch (e) {}
    this.apollo = true;
    return;
    if (ends.inApp) {
      let deviceid = this.params.get("deviceid");
      if (!deviceid) {
        return;
      }
      let that = this;
      window.Apollo.getToggle(
        {
          name: "ibt_br_register",
          location_country: "BR",
          key: deviceid,
          device_id: deviceid
        },
        function(result) {
          if (!result.code) {
            var toggle = result.data.ibt_br_register; // 或者 result.data['exp_or_toggle_name']
            if (toggle) {
              if (toggle.isAllow()) {
                // 进入灰度
                that.apollo = toggle.groupName === "new";
                if (that.apollo) {
                  Omega.trackEvent("apollo_toggle", "", { new_pro: deviceid });
                } else {
                  Omega.trackEvent("apollo_toggle", "", { old_pro: deviceid });
                }
              }
            } else {
              // 没有找到开关命名，请检查是否在正确的环境下创建了开关
              console.log("toggle not found");
            }
          } else {
            // 请求出错，这里可以获得错误code和message
            console.log("code: " + result.code + ", " + result.message);
          }
        }
      );
    } else {
      //端外全部走新版sdk
      this.apollo = true;
    }
  },
  methods: {
    ...mapMutations(["setState"]),
    //passport登录
    login(cate) {
      showLoadingToast(this, this.$t("加载中"), 1500);
      let up = new URLSearchParams(location.search);
      up.set("product_id", cate.pid); //兼容老逻辑传参
      up.set("product", cate.pid);
      up.set("category", cate.category);
      try {
        Omega.trackEvent("gd_carType_btn_ck", "", {
          carType: cate.pid,
          appsflyer_uid: this.params.get("appsflyer_uid")
        });
      } catch (e) {}

      //如果存在ticket，直接跳过登录流程
      //todo 非巴西，国家，有乘客端ticket传过来的case，注意下
      if ((up.get("ticket") || up.get("token")) && !ends.isPassengerTerminal) {
        this.setState({ _product: cate.pid });
        // location.href = `${cate.redirectUrl}?${up}`;
        this.$router.replace({ name: "home" });
        return;
      }
      if (this.apollo) {
        login.login(
          ({ ticket, cell, uid }) => {
            this.setState({
              _ticket: ticket,
              _cell: cell,
              _product: cate.pid,
              _uuid: uid
            });
            // up.set("ticket", ticket);
            // if (ends.inApp) {
            //   up.set("cell", cell);
            // }
            // up.set("uid", uid);
            // //@20190809 临时修复 datatype的逻辑问题--跳转后需把datatype干掉，日后巴西迁移完毕，使用路由可彻底解决此问题
            // if (ends.isPassengerTerminal) {
            //   up.set("datatype", "");
            // }
            // location.href = `${cate.redirectUrl}?${up}`;
            this.$router.replace({ name: "home" });
          },
          error => console.log(error)
        );
      } else {
        //执行老版本
        showLoadingToast(this);
        let o = {};
        o.appsflyer_uid = up.get("appsflyer_uid") || "";
        o.product_id = cate.pid;
        o.channel = up.get("channel");
        o.category = cate.category;
        o.redirect_url = `${cate.redirectUrl}?${up}`;
        let up2 = new URLSearchParams(o);
        location.href = `${this.loginUrl}?${up2}#/register`;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$padLeft: 0.5rem;
.s-bold {
  font-weight: bold !important;
}

.h-bold {
  font-weight: bold !important;
}

#login {
  width: 100%;
  background: #fff;
  header {
    height: 3.43rem;
    font-size: 0.72rem;
    color: #fff;
    background: #292a34;
    .title {
      height: 2.25rem;
      padding-left: $padLeft;
      padding-top: 0.59rem;
      text-align: left;
      div {
        font-weight: 200;
      }
    }
  }
  .cates {
    li {
      position: relative;
      height: 2.2rem;
      box-sizing: border-box;
      img {
        position: absolute;
        left: 0.11rem;
        top: 0.44rem;
        width: 2.37rem;
        height: 1.01rem;
      }
      .info {
        position: absolute;
        top: 50%;
        left: 3.4rem;
        font-size: 0;
        color: #999;
        text-align: left;
        transform: translateY(-50%);
        span {
          font-size: 0.32rem;
          color: #313133;
        }
        div {
          width: 2.93rem;
          padding-top: 0.08rem;
          font-size: 0.28rem;
          font-weight: 200;
        }
      }
      .arrow {
        position: absolute;
        right: 0.6rem;
        top: 50%;
        width: 0.18rem;
        height: 0.18rem;
        border-right: 2px solid #191d1f;
        border-bottom: 2px solid #191d1f;
        transform: translateY(-50%) rotate(-45deg);
      }
      &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        content: "";
        border-bottom: 1px solid #e1e2e6;
        transform: scaleY(0.5);
      }
    }
  }
  .income {
    .titles {
      height: 3.11rem;
      padding-left: $padLeft;
      font-size: 0.72rem;
      text-align: left;
      background-color: #f3f5f6;
      .tip1 {
        padding-top: 0.54rem;
        color: #292a34;
      }
      .tip2 {
        font-weight: 200;
        color: #000016;
      }
    }

    .login-intro {
      width: 100%;
      .login-intro-list {
        position: relative;
        width: 100%;
        height: 1.7rem;
        .login-intro-icon {
          position: absolute;
          left: 0.6rem;
          top: 50%;
          width: 0.61rem;
          height: 0.63rem;
          transform: translateY(-50%);
        }
        div {
          position: absolute;
          left: 1.41rem;
          top: 50%;
          text-align: left;
          transform: translateY(-50%);
        }
        .login-intro-title {
          font-size: 0.32rem;
          color: #4b4b4d;
        }
        .login-intro-desc {
          font-size: 0.24rem;
          color: #7d7d80;
        }
      }
    }
  }
}
</style>

